import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security"
import { Navigate } from "react-router-dom";

import LoginPageMain from 'Modules/loginPage/main'

const CloudLoginPageView = (props) => {
    return (
        <div>
            <LoginPageMain />
        </div>
    )
}
export default CloudLoginPageView